var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-venue-page"},[_c('Title',{staticClass:"mx-auto"},[_vm._v("Register the venue")]),_c('VenueForm',{attrs:{"value":_vm.venue,"submitButtonText":"Register","isSubmitting":_vm.isSubmitting,"isIdEditable":true},on:{"submit":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }